import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var MatchPipe = (function () {
    function MatchPipe() {
    }
    MatchPipe.prototype.transform = function (text, pattern, flags) {
        if (!isString(text)) {
            return text;
        }
        return text.match(new RegExp(pattern, flags));
    };
    MatchPipe.decorators = [
        { type: Pipe, args: [{ name: 'match' },] },
    ];
    /** @nocollapse */
    MatchPipe.ctorParameters = function () { return []; };
    return MatchPipe;
}());
export { MatchPipe };
//# sourceMappingURL=match.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/match.js
// module id = 283
// module chunks = 4